import { observer } from 'mobx-react-lite';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { AppRoutes } from 'routes/AppRoutes';
import authStore from 'stores/auth/AuthStore';


const ProtectedRoute = observer(({ children }: any) => {
    if (!authStore.isAuthenticated) {
        return <Navigate to={AppRoutes.LOGIN} />;
    }
    return <>{children}</>;
});

export default ProtectedRoute;

